import { fetchRuleInfo } from '@/apis/afterSales/afterSales.api';
import { RuleInfoVO } from '@/apis/afterSales/afterSales.interface';
import to from 'await-to-js';
import { useEffect, useState } from 'react';
import styles from './index.module.scss';
// 图标
import InfoIcon from '@/assets/icons/InfoIcon.svg';
import Expand from '@/assets/icons/chevron-down.svg';

const RuleWrap = () => {
  // rules
  const [ruleList, setRuleList] = useState<RuleInfoVO[] | []>([]);
  // 查询售后配置规则信息
  const loadRuleInfo = async () => {
    const [err, ruleInfoData] = await to(fetchRuleInfo());

    if (err) {
      // setError("Failed to fetch address list");
      setRuleList([]);
    } else {
      if (ruleInfoData?.ruleVOList?.length) {
        const showRuleList = ruleInfoData?.ruleVOList.filter((item) => item.ruleType === 2);
        setRuleList(showRuleList as RuleInfoVO[]);
      } else {
        setRuleList([]);
      }
    }
  };

  useEffect(() => {
    loadRuleInfo();
  }, []);

  if (!ruleList?.length) {
    return;
  }

  return (
    <>
      <div
        className={styles.ruleWrap}
        onClick={() => {
          ruleList[0]?.jumpUrl && window.open(ruleList[0]?.jumpUrl);
        }}
      >
        <InfoIcon className={styles.tipIco} />
        <div className={styles.ruleContent}>{ruleList[0]?.title}</div>
        <Expand className={styles.entryIco} />
      </div>
    </>
  );
};

export default RuleWrap;
